import React from "react";
import { Box, Grid, Typography, Container, Card, CardContent, CardMedia } from "@mui/material";
import appImage from "../images/app.png";
import customizationImage from "../images/customization.png";
import supportImage from "../images/support.png";
import { Fade } from "react-reveal";

const WhyChooseSection = () => {
  const features = [
    {
      title: "Detailed Investment Details",
      description: "Stay informed about your investments with detailed information on mutual funds, demat trading, insurance, and more. Track your portfolio performance, investment options, and more.",
      image: appImage
    },
    {
      title: "Expert Financial Advice",
      description: "Tap into the expertise of our financial consultants for personalized advice, financial planning strategies, and investment guidance tailored to your unique financial goals.",
      image: customizationImage
    },
    {
      title: "24/7 Customer Support",
      description: "Our customer care support is available 24/7 to provide prompt and reliable assistance with any financial questions or concerns you may have.",
      image: supportImage
    }
  ];

  return (
    <Box component="section" py={6}>
      <Container maxWidth="lg">
        {/* Heading Section */}
        <Grid container justifyContent="center" mb={6}>
          <Grid item xs={12} md={8} textAlign="center">
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              sx={{
                whiteSpace: { md: "nowrap" },
                fontSize: {
                  xs: "1.8rem", // Mobile
                  sm: "2.2rem", // Tablet
                  md: "2.6rem"  // Desktop and up
                },
                color: "#FFF"
              }}
            >
              Why you should choose our app
            </Typography>

            <Typography
              variant="body1"
              sx={{ fontSize: "1.2rem" }}
            >
              Choose our app for secure, easy access to store and manage your financial details, including mutual funds, demat trading, insurance, assets, and more, with expert support from financial consultants.
            </Typography>
          </Grid>
        </Grid>

        {/* Feature Cards */}
        <Grid container spacing={4}>
          {features.map((feature, index) => (
            <Grid item xs={12} md={4} key={index}>
              <Fade bottom delay={index * 300}>
                <Card
                  sx={{
                    textAlign: "center",
                    p: 2,
                    background: "rgba(255, 255, 255, 0.15)",
                    borderRadius: "20px",
                    backdropFilter: "blur(10px)",
                    WebkitBackdropFilter: "blur(10px)",
                    border: "1px solid rgba(255, 255, 255, 0.3)",
                    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
                    transition: "0.3s",
                    "&:hover": {
                      boxShadow: "0 8px 24px rgba(0, 0, 0, 0.3)",
                      transform: "scale(1.05)"
                    }
                  }}
                >
                  <CardMedia
                    component="img"
                    src={feature.image}
                    alt={feature.title}
                    sx={{
                      width: 90,
                      height: 90,
                      mx: "auto",
                      mt: 2,
                      mb: 3,
                      borderRadius: "50%"
                    }}
                  />
                  <CardContent sx={{ paddingBottom: 4 }}>
                    <Typography variant="h5" fontWeight="bold" sx={{ mb: 3, color: "#FFF" }}>
                      {feature.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: "#FFF" }}>{feature.description}</Typography>
                  </CardContent>
                </Card>
              </Fade>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
};

export default WhyChooseSection;
